// extracted by mini-css-extract-plugin
export var container = "_oz-0";
export var dotAnimation = "_oz-2";
export var dotsLoading = "_oz-1";